export default "__VITE_ASSET__DBQLLQ_l__"